<script setup>
import { useNotificationStore } from "@/stores/NotificationStore"
import { useLayoutConfigStore } from '@layouts/stores/config'
import { sanitizeHtml } from "@/utils/strings"
// import { useDisplay } from "vuetify/framework"
//
// const { mobile } = useDisplay()
const notificationStore = useNotificationStore()
const configStore = useLayoutConfigStore()
</script>

<template>
  <div v-if="notificationStore.topNotificationCounter > 0">
    <VAlert
      v-for="(notification, idx) in notificationStore.topNotificationList"
      :key="`top-notification-${idx}`"
      class="w-100 text-center border-b-thin top-notification"
      :style="configStore.isVerticalNavCollapsed ? `1rem` : `padding-left:280px`"
      style="border-radius: 0!important;"
      :icon="false"
      :type="notification.type"
      :closable="notification.closable"
    >
      <span v-html="sanitizeHtml(notification.message)" />
    </VAlert>
  </div>
</template>

<style>
@media (max-width: 1279px) {
  .top-notification {
    padding-left: 1rem!important;
  }
}
.top-notification {
  a {
    color: white!important;
    text-decoration: underline!important;
    font-weight: bold;
  }
}
</style>
